import { IAsset } from '../../constants/assets';
import {
  RelatedTexts,
  LaterExemplar,
  ExemplarRelationships,
  RelatedType,
  EditedExemplar,
  AWSImage,
  EditedSavedExemplar,
} from '../../types';
import { AxiosPrivate } from '../../utils';

export interface IData {
  data: {
    id: number;
    textType: string;
    content: LaterExemplar;
    related: RelatedTexts;
    relationships: ExemplarRelationships;
    assets: IAsset[];
  };
}

interface ImageInterface {
  total: number;
  data: Array<AWSImage>;
}

class ExemplarApi {
  private static instance: ExemplarApi;

  public static getInstance(): ExemplarApi {
    if (!ExemplarApi.instance) {
      ExemplarApi.instance = new ExemplarApi();
    }

    return ExemplarApi.instance;
  }

  saveExemplar = (exemplar: EditedExemplar) => {
    const body = {
      data: {
        title: exemplar.title,
        page: exemplar.page,
        content: exemplar.content,
        tools: exemplar.tools,
      },
    };

    return AxiosPrivate.post<IData>(
      `/v1/${RelatedType.exemplars}/${exemplar.id}/${RelatedType.saved_exemplars}`,
      JSON.stringify(body)
    );
  };

  saveExemplarFromSaved = (savedExemplar: EditedExemplar) => {
    const body = {
      data: {
        title: savedExemplar.title,
        page: savedExemplar.page,
        content: savedExemplar.content,
        tools: savedExemplar.tools,
      },
    };

    return AxiosPrivate.post<IData>(
      `/v1/${RelatedType.saved_exemplars}/${savedExemplar.id}/${RelatedType.saved_exemplars}`,
      JSON.stringify(body)
    );
  };

  getExemplar = (id: number) => {
    return AxiosPrivate.get<IData>(`/v1/exemplars/${id}`);
  };

  getSavedExemplar = (id: number) => {
    return AxiosPrivate.get<IData>(`/v1/saved_exemplars/${id}`);
  };

  getImages = () => {
    return AxiosPrivate.get<ImageInterface>('/v1/images');
  };

  updateSavedExemplar = (savedExemplar: EditedSavedExemplar) => {
    const body = {
      data: {
        content: savedExemplar.content,
        tools: savedExemplar.tools,
      },
    };

    return AxiosPrivate.put<IData>(`/v1/${RelatedType.saved_exemplars}/${savedExemplar.id}`, JSON.stringify(body));
  };

  deleteSavedExemplar = (id: number) => {
    return AxiosPrivate.delete(`/v1/saved_exemplars/${id}`);
  };

  deleteSavedProforma = (id: number) => {
    return AxiosPrivate.delete(`/v1/saved_proformas/${id}`);
  };
}

export const exemplarApi = ExemplarApi.getInstance();
